import { useEffect, useState, useCallback } from 'react'
import { getDocument } from 'services/api/firebase'
import { COLLECTIONS } from '__constants__'

/**
 * It fetches a newspaper document from Firestore and returns it
 * @param newsTip - The newsTip object that we're getting the newspaper for.
 * @returns An array with four values. The first value is the newspaper object, and the second value is a
 * boolean that indicates whether the newspaper is loading.
 */
const useGetNewsTipNewspaper = (newsTip) => {
  /* State for data */
  const [newspaper, setNewspaper] = useState(null)
  /* State for loading */
  const [loading, setLoading] = useState(!!newsTip?.newspaperId)
  /* State for error */
  const [error, setError] = useState(null)

  /* Fetching data */
  const getNewspaper = useCallback(async () => {
    try {
      setLoading(true)
      const document = await getDocument(
        COLLECTIONS.NEWSPAPERS,
        newsTip.newspaperId
      )
      setNewspaper(document)
      setLoading(false)
    } catch (error) {
      setError(error)
    }
  }, [newsTip?.newspaperId])

  useEffect(() => {
    newsTip?.newspaperId && getNewspaper()
  }, [newsTip?.newspaperId, getNewspaper])

  return [newspaper, loading, error, getNewspaper]
}

export default useGetNewsTipNewspaper
